import clsx from 'clsx';
import { ReactNode } from 'react';
import {
  PageGeometry,
  resolvePaginatedBottomPaddingMm,
} from '../utils/resolvePageGeometry';
import { ReportPageSetup } from '../types';

interface ReportSheetProps {
  page: ReportPageSetup;
  geometry: PageGeometry;
  /** 1-based; shown as "n / total" in the sheet corner. */
  pageNumber?: number;
  pageCount?: number;
  children: ReactNode;
}

/**
 * One sheet of paper.
 *
 * Both dimensions are fixed to the paper size, so the preview is the printed
 * result rather than a strip in the right width. The frame is drawn on the sheet
 * itself, which means every page of a framed report is framed.
 */
const ReportSheet = ({
  page,
  geometry,
  pageNumber,
  pageCount,
  children,
}: ReportSheetProps) => (
  <div
    className={clsx(
      'report-sheet',
      page.border && 'report-sheet--bordered'
    )}
    style={{
      width: `${geometry.sheetWidthMm}mm`,
      height: `${geometry.sheetHeightMm}mm`,
      padding: `${page.marginMm}mm`,
      paddingBottom: `${resolvePaginatedBottomPaddingMm(
        page.marginMm,
        pageCount ?? 1
      )}mm`,
    }}
  >
    <div className="report-sheet-content">{children}</div>
    {pageCount !== undefined && pageCount > 1 && (
      <span className="report-sheet-pagination">
        {pageNumber} / {pageCount}
      </span>
    )}
  </div>
);

export default ReportSheet;
